import nls from '../es/SuccessPage';
export default {
  ...nls,
  'Congratulations! Your request was successfully registered': '¡Felicidades! Su solicitud se registró exitosamente',
  'Go to your branch for your Contract, Cover, Commission Annex and Amortization Table': 'Acuda a sucursal por su Contrato, Carátula, Anexo de Comisiones y Tabla de Amortización',
  'Go to your branch for your Contract, Cover and Annex of Commissions.': 'Acuda a sucursal por su Contrato, Carátula y Anexo de Comisiones.',
};
